import './../css/App.css';
import React, { Component } from 'react';
import ImageLink from './../js/ImageLink'
import { IndexLink, Link } from 'react-router';
import foodbaby_logo from './../images/foodbaby_logo.png';
import nav_links from './../images/nav_links.png';
import nav_links_hover from './../images/nav_links_hover.png';
import nav_press from './../images/nav_press.png';
import nav_press_hover from './../images/nav_press_hover.png';
import nav0_insta from './../images/nav0_insta.png';
import nav0_insta_hover from './../images/nav0_insta_hover.png';
import nav1_fb from './../images/nav1_fb.png';
import nav1_fb_hover from './../images/nav1_fb_hover.png';
import nav2_tw from './../images/nav2_tw.png';
import nav2_tw_hover from './../images/nav2_tw_hover.png';
import nav3_snap from './../images/nav3_snap.png';
import nav3_snap_hover from './../images/nav3_snap_hover.png';
import nav4_yt from './../images/nav4_yt.png';
import nav4_yt_hover from './../images/nav4_yt_hover.png';
import nav5_email from './../images/nav5_email.png';
import nav5_email_hover from './../images/nav5_email_hover.png';

class Nav extends Component {
  render() {
      return (
        <div>
          <div className="nav">
          <div className="nav-image">
              <IndexLink to="/"><img src={foodbaby_logo} alt="logo" /></IndexLink>
          </div>
            <div className="nav-links">
              <Link to="/press" activeClassName="active"><ImageLink imagePath={nav_press} imagePathHover={nav_press_hover}></ImageLink></Link>
              <Link to="/links" activeClassName="active"><ImageLink imagePath={nav_links} imagePathHover={nav_links_hover}></ImageLink></Link>
            </div>
            <div className="nav-social">
            <ImageLink imagePath={nav0_insta} imagePathHover={nav0_insta_hover} href="https://instagram.com/foodbabyny"></ImageLink>
            <ImageLink imagePath={nav1_fb} imagePathHover={nav1_fb_hover} href="https://facebook.com/foodbabyny"></ImageLink>
            <ImageLink imagePath={nav2_tw} imagePathHover={nav2_tw_hover} href="https://twitter.com/foodbabyny"></ImageLink>
            <ImageLink imagePath={nav3_snap} imagePathHover={nav3_snap_hover} href="https://www.snapchat.com/add/foodbabyny"></ImageLink>
            <ImageLink imagePath={nav4_yt} imagePathHover={nav4_yt_hover} className="yt" href="https://www.youtube.com/channel/UCxY9NzS9VKsTB9XF2-cm3Lg"></ImageLink>
            <ImageLink imagePath={nav5_email} imagePathHover={nav5_email_hover} className="email" href="mailto:foodbabyny@gmail.com"></ImageLink>
            </div>
          </div>
          <div className="content">
            {this.props.children}
          </div>
        </div>
      )
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/js/Nav.js